import { useEffect } from 'react';

type Callback = () => void;

const useEventListenerOnElement = <T extends Element>(
  element: T,
  eventType: keyof DocumentEventMap,
  callback: Callback,
) =>
  useEffect(() => {
    element.addEventListener(eventType, callback);

    return () => {
      element.removeEventListener(eventType, callback);
    };
  }, [element, eventType, callback]);

export const useResizeEventListenerOnElement = <T extends Element>(
  element: T,
  callback: Callback,
) => useEventListenerOnElement(element, 'resize', callback);

export default useEventListenerOnElement;
